export class BoardAccessResultDto {
  communityId: number;
  titleCode: string;
  title: string;
  termExpires: string;

  // Mirrors the authoritative backend gate in RES-552
  // UserRepository.GetBoardAccess: `TERM_EXPIRES IS NULL OR TERM_EXPIRES > GETUTCDATE()`.
  //   - A null/absent termExpires is a non-expiring grant → active.
  //   - Otherwise the grant is active while its expiry date (UTC midnight) is
  //     still in the future, i.e. access ends at the START of the expiry date on
  //     a UTC basis (termExpires is the first INVALID day, exclusive). termExpires
  //     comes serialized without a timezone (e.g. "2027-03-31T00:00:00"), so we
  //     compare via Date.UTC(y,m,d) to match the server's GETUTCDATE() basis
  //     rather than the browser's local zone.
  get isTermActive(): boolean {
    if (!this.termExpires) {
      return true;
    }
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(this.termExpires);
    if (!parts) {
      return false;
    }
    const [, year, month, day] = parts;
    return Date.UTC(Number(year), Number(month) - 1, Number(day)) > Date.now();
  }
}
